import { Flex, Text } from '@wyz/ui';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { Trans, useLocale } from '~/common/context';

type Props = {
  name: string;
  price: number | null;
  onChange?: (quantity: number) => void;
  currency: string;
};

function QuantitySelector({ name, price, onChange, currency }: Props) {
  const methods = useFormContext();
  const watchedQuantity = methods.watch(name);
  const locale = useLocale();

  return (
    <Flex className='gap-2' justifyContent='between'>
      {[1, 2, 4].map((quantity) => {
        const isSelected = quantity === watchedQuantity;
        return (
          <div
            key={quantity}
            className={clsx(
              'py-1 px-1 flex-1 text-center cursor-pointer rounded border border-1 position-relative overflow-hidden',
              {
                'border-neutral-grey-4': !isSelected,
                'border-tertiary-bold': isSelected,
                'bg-light-blue': isSelected,
              },
            )}
            onClick={() => {
              methods.setValue(name, quantity);
              onChange?.(quantity);
            }}
          >
            <Text
              heading='sm'
              id={`product-quantity-${quantity}`}
              weight={isSelected ? 'semi-bold' : 'normal'}
              color={isSelected ? 'tertiary-bold' : 'secondary-gray'}
            >
              <Trans
                i18nKey='app.quote.tyre_count'
                values={{
                  count: quantity,
                }}
              />
            </Text>
            <Text
              heading='xs'
              id={`product-price-${quantity}`}
              weight='normal'
              color={isSelected ? 'tertiary-bold' : 'secondary-gray'}
              className='text-nowrap'
            >
              {price === null ? (
                '-'
              ) : (
                <Trans
                  i18nKey='app.purchase.quote_search_page.product.price_with_taxes'
                  values={{
                    price: locale.formatters.money(quantity * price, {
                      currency: currency,
                    }),
                  }}
                />
              )}
            </Text>
          </div>
        );
      })}
    </Flex>
  );
}

export default QuantitySelector;
